module.exports = __webpack_public_path__ + "img/section4_img.058c43ac.svg";